import { createUseStyles } from 'react-jss'
import { colors } from 'components/common'

const useSoundsSelectStyles = createUseStyles({
  soundsControlleWrapper: {
    '& > label': {
      fontWeight: 'bold',
      color: colors.gray600,
      fontSize: 12,
      margin: '0.5rem 0'
    }
  },

  soundsControllerContent: {
    '&.disabled': {
      opacity: '0.4',
      pointerEvents: 'none'
    }
  },

  soundsListWrapper: {
    margin: '1rem 0',

    '& > .selected-sound-item': {
      color: colors.theme600,
      backgroundColor: colors.gray25,
      padding: '0.5rem 1rem',
      margin: '0.25rem 0',

      '& > span': {
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    },

    '& > .no-sounds-text': {
      color: colors.gray300,
      margin: '0 auto'
    }
  },

  soundsSelectButton: {
    padding: '6px 12px',
    lineHeight: '24px',
    height: 40,
    backgroundColor: '#fff',
    border: `1px solid ${colors.gray200}`,
    borderRadius: 4,
    cursor: 'pointer',

    '& > i': {
      marginRight: '0.5rem'
    }
  }
})

export { useSoundsSelectStyles }
